import * as React from "react";
import PropTypes from "prop-types";
import DarkModeInverter from "nexia_mobile/components/DarkModeInverter";
import nexiaLogo from "nexia_mobile/styl/images/nexia_logo.svg";

const styles = {
  backgroundStyle: {
    display: "inline-block",
    backgroundSize: "100%",
    backgroundRepeat: "no-repeat",
  },
};

const LockScreenBrandLogo = ({ width, height }) => {
  return (
    <DarkModeInverter>
      {({ maybeInvert }) => {
        return (
          <span
            data-component-name="LockScreenBrandLogo"
            style={{
              ...styles.backgroundStyle,
              backgroundImage: `url(${nexiaLogo})`,
              width,
              height,
              ...maybeInvert,
            }}
          />
        );
      }}
    </DarkModeInverter>
  );
};
LockScreenBrandLogo.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};
LockScreenBrandLogo.defaultProps = {
  width: "8em",
  height: "3.5em",
};

export default LockScreenBrandLogo;



// WEBPACK FOOTER //
// ./src/components/BrandLogo/LockScreenBrandLogo.jsx